import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      padding: 20,
      borderRadius: '8px',
      background: 'var(--x-bg-1)',
      boxShadow: '0px 1px 4px 0px var(--x-shadow-card)',
    },
  }),
  {
    name: 'card',
  },
);

export default useStyles;
